<template>
  <div class="Moyens">
    <p class="SubTitle">{{langPage['v4-moyens']['TXT_moyendepaiement']}}</p>
    <addCarte
      :msg="msg"
      :carteTitle="carteTitle"
      :genre="1"
      buttonVal=" Utiliser une nouvelle carte"
    ></addCarte>
  </div>
</template>
<script>
import addCarte from "../../components/addCarte";
import {mapState} from "vuex";
export default {
  name: "Moyens",
  components: {
    addCarte
  },
  computed: {
    langPage() {
      return this.$store.state['langPage']
    }
  },
  data() {
    return {
      carteTitle: [
        {
          title: "Numéro de carte",
          key: "a",
          rule: [{ required: true, message: "Numéro de carte", trigger: "blur" }]
        },
        {
          title: "Titulaire de la carte",
          key: "b",
          rule: [{ required: true, message: "Numéro de carte", trigger: "blur" }]
        },
        {
          title: "Date d’expiration",
          key: "c",
          rule: [{ required: true, message: "Numéro de carte", trigger: "blur" }]
        },
        {
          title: "Code de sécurité (CCV) ",
          key: "d",
          rule: [{ required: true, message: "Numéro de carte", trigger: "blur" }]
        }
      ],
      msg: [
        {
          a: "Speed Transport 2000",
          b: "1324567891022",
          c: "Expire le",
          d: "19/20"
        }
      ]
    };
  },
  methods: {}
};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Moncompte/Moyens.less">
</style>
